<template>
  <form @submit.prevent="handleSubmit">
    <b-row class="m-0">
      <b-col md="12" class="mt-3">
        <div class="border p-3 card-sr-information-form mb-3" v-for="(item, index) in multipleSelected" :key="index">
          <b-row>
            <b-col lg="12 mt-3">
              <HeaderDetailItemSR :selectedItem="item" :optionsTaskType="optionsTaskType"
                :optionsDepartment="optionsDepartment" :optionsCategory="optionsCategory"
                :optionsClassification="optionsClassification" :optionsCause="optionsCause"
                :optionsKindTask="optionsKindTask" :isApprove="true" />
              <!-- :editable="true" -->
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="my-3 mt-4 d-flex justify-content-end">
        <b-button type="button" variant="outline-primary" class="mr-2" @click="$emit('close')">Close Approve</b-button>
        <b-button v-if="!loading" type="submit" variant="primary">Save Approve</b-button>
        <b-button v-else type="button" variant="primary">
          <b-spinner small class="mr-2"></b-spinner> Loading...
        </b-button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { srActions } from '@/src/Utils/helper'
import ListInternalManPower from './ListInternalManPower.vue'
import ListSubContractor from './ListSubContractor.vue'
import moment from '@/node_modules/moment/moment'
import HeaderDetailItemSR from './HeaderDetailItemSR.vue'

export default {
  name: 'FormItemSR',
  components: {
    ListInternalManPower,
    ListSubContractor,
    HeaderDetailItemSR,
  },
  props: {
    formId: null,
    selectedItem: {
      type: Object,
      default: () => { },
    },
    multipleSelected: {
      type: Array,
      default: () => [],
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      status: false,
    }
  },
  methods: {
    ...srActions,
    async onApproveServiceAndRepair() {
      try {
        this.loading = true
        const user_id = JSON.parse(localStorage.getItem('profile')).id
        const items = this.multipleSelected.map((item) => {
          return {
            id: item.id,
            status: item.isApprove,
            // cost_real: item?.cost_real,
            cost_real: 0,
          }
        })
        const formApprove = {
          user_id,
          user_name: JSON.parse(localStorage.getItem('profile')).userDetail
            .name,
          data: items,
        }
        const res = await this.approveSr({
          id: this.formId,
          data: formApprove,
          params: { user_id },
        })
        if (res.status === 'success') {
          this.$swal(
            `Berhasil!`,
            `Approve Service & Repair berhasil.`,
            'success'
          )
          this.$emit('refetch')
          this.loading = false
        } else {
          this.$emit('refetch')
          this.loading = false
          this.$swal(`Oops!`, `${res.data.message}`, 'error')
        }
      } catch (error) {
        this.$swal(`Oops!`, `${error.message}`, 'error')
      }
    },
    handleSubmit() {
      if (this.formId) {
        this.onApproveServiceAndRepair()
      }
    },
    onAddManpower(item, manPowers) {
      item.internal_manpower.push({ ...manPowers })
    },
    onAddSubcon(item, value) {
      item.subcons.push(...value)
    },
    onDeleteManpower(item, val) {
      item.man_powers = item.man_powers.filter((el, idx) => idx !== val)
    },
  },
  mounted() { },
}
</script>
<style scoped>
.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.text-red {
  color: red;
}
</style>
